// 在线客服（原生接入客服系统，访客端协议与 app 的匿名访客一致）
// 地址和收件箱标识见 .env：VUE_APP_CS_BASE_URL / VUE_APP_CS_INBOX
export const CS_BASE_URL = (process.env.VUE_APP_CS_BASE_URL || '').replace(/\/+$/, '')
export const CS_INBOX = process.env.VUE_APP_CS_INBOX || ''
export const CS_WS_URL = CS_BASE_URL.replace(/^http/, 'ws') + '/cable'

// 来源标识：客服系统按它在坐席端显示「来源：官网」并给会话打标签
export const CS_SOURCE = 'ldpg'

export const csEnabled = () => Boolean(CS_BASE_URL && CS_INBOX)
